var _path;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27D367",
    d: "M14.56 11.984c-.247-.124-1.465-.724-1.692-.806-.227-.083-.392-.124-.557.124-.165.247-.64.806-.785.97-.144.166-.29.186-.536.062a6.763 6.763 0 0 1-1.991-1.228A7.458 7.458 0 0 1 7.62 9.39c-.144-.248-.015-.382.109-.505.11-.111.248-.29.37-.434a1.69 1.69 0 0 0 .249-.413.455.455 0 0 0-.021-.434c-.062-.124-.557-1.343-.763-1.84-.201-.481-.405-.416-.558-.424a10.118 10.118 0 0 0-.474-.01.91.91 0 0 0-.66.312 2.777 2.777 0 0 0-.867 2.065c.08.934.432 1.824 1.01 2.562a11.034 11.034 0 0 0 4.23 3.739c.462.198.934.372 1.413.522.505.153 1.04.186 1.56.097a2.543 2.543 0 0 0 1.67-1.176c.163-.37.213-.78.145-1.178-.061-.104-.226-.165-.474-.29Zm2.492-9.08a9.913 9.913 0 0 0-15.598 11.96L.048 19.998l5.254-1.377a9.904 9.904 0 0 0 4.736 1.206h.004a9.915 9.915 0 0 0 7.01-16.922Zm-2.633 13.99a8.246 8.246 0 0 1-4.377 1.259h-.004a8.223 8.223 0 0 1-4.192-1.15l-.301-.177-3.118.818.832-3.04-.195-.312a8.237 8.237 0 1 1 11.355 2.602Z"
  })));
};

export { SvgWhatsapp as ReactComponent };
export default "/_next/static/media/whatsapp.0ecfecb6.svg";